import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  // findStudent({ commit }, params) {
  // 	return new Promise((resolve, reject) => {
  // 		axios.post(`student/findStudent`, params)
  // 			.then(response => {
  // 				resolve(response)
  // 			})
  // 			.catch(error => {
  // 				reject(error)
  // 			})
  // 	})
  // },

  findStudent({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findByList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // findStudentById({ commit }, params) {
  // 	return new Promise((resolve, reject) => {
  // 		axios.post(`student/findStudentById`, params)
  // 			.then(response => {
  // 				resolve(response)
  // 			})
  // 			.catch(error => {
  // 				reject(error)
  // 			})
  // 	})
  // },

  findStudentById({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findById`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // studentSave({ commit }, params) {
  // 	return new Promise((resolve, reject) => {
  // 		axios.post(`student/studentSave`, params)
  // 			.then(response => {
  // 				resolve(response)
  // 			})
  // 			.catch(error => {
  // 				reject(error)
  // 			})
  // 	})
  // },

  studentSave({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/save`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  studentSaveInStudentList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/saveByBaokao`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  // studentDelete({ commit }, params) {
  // 	return new Promise((resolve, reject) => {
  // 		axios.get(`student/studentDelete`, {params})
  // 			.then(response => {
  // 				resolve(response)
  // 			})
  // 			.catch(error => {
  // 				reject(error)
  // 			})
  // 	})
  // },

  studentDelete({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/delStudent`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  intDictionary({commit}, params) {
    return new Promise((resolve, reject) => {
      let getGaokaoYear = axios.get("/dictionary/findAllItemByTypeCode", {params: {typeCode: "gaokaoYear"}})
      Promise.all([getGaokaoYear])
        .then(res => {
          resolve(res)
        }).catch(error => {
        console.log(error)
      })
    })
  },
  // 省市区
  findProvinceList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findProvinceList`, {params})
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })

  },
  findCityListByProvinceCode({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findCityListByProvinceCode`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findAreaListByCityCode({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findAreaListByCityCode`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  checkByIdnumberOrMobile({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/checkByIdnumberOrMobile`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  outStudent({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/outStudent`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findOrderByCustomerId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findOrderByCustomerId`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findRedeemByCustomerId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findRedeemByCustomerId`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findVipLevel({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findVipLevel`, params)
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  findByOrgIdOfTeacherList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findByOrgIdOfTeacherList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  studentChange({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/studentChange`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  findByPersonList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/findByPersonList`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  resetPassword({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/resetPassword`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // resetPassword({ commit }, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`studentInfoNew/resetPassword`, params)
  //   .then(response => {
  //     resolve(response)
  //   }).catch((error) => {
  //     reject(error)
  //   })
  // },

  // studentExportScheme({commit}, params) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`studentInfoNew/studentExportScheme`, params)
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },

  studentExportScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/studentInfoNew/studentExportScheme',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },

  studentImportExcel({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`studentInfoNew/studentImportExcel`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  checkByMobile({ commit }, params) {
    return new Promise((resolve, reject     ) => {
      axios.post(`studentInfoNew/checkByMobile`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  findByMobile({ commit }, params) {
    return new Promise((resolve, reject     ) => {
      axios.post(`studentInfoNew/findByMobile`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  studentChangeById({ commit }, params) {
    return new Promise((resolve, reject     ) => {
      axios.post(`studentInfoNew/studentChangeById`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  exportData({ commit }, params) {
    return new Promise((resolve, reject     ) => {
      axios.post(`studentInfoNew/exportData`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
